import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import CallFab from "./components/CallFab";

export default function App() {
  return (
    <div className="min-h-screen bg-white text-gray-900 scroll-smooth">
      <Navbar />
      <Home />
      <Footer />
      <CallFab />
    </div>
  );
}
